// Actions for recording management
export const setSupervisedAgentDetails = (supervisedAgentDetails) => ({
  type: "SET_SUPERVISED_AGENT_DETAILS",
  payload: supervisedAgentDetails,
});

export const setSupervisedAgentIds = (supervisedAgentIds) => ({
  type: "SET_SUPERVISED_AGENT_IDS",
  payload: supervisedAgentIds,
});

export const setCallFlowsIds = (callFlowsIds) => ({
  type: "SET_CALL_FLOWS_IDS",
  payload: callFlowsIds,
});
